import styled from 'styled-components';

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-width: 600px;
    width: 100%;
    min-height: 100vh;
`;
